import React, {Component} from 'react';
import {connect} from 'react-redux';
// style
import style from '../css/fullScreenConfirmationPopup.css';
import {goFullScreen} from "../../../helpers/layoutHelpers";
import {openCloseModal} from "../../../actions/modalActions";
import {getText} from "../../../helpers/localization";

const mapStateToProps = (state, ownProps) => {
    return {
        isModalOpen: state.vpp.isModalOpen,
        openModalType: state.vpp.openModalType,
    };
};

class FullScreenConfirmationPopup extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            isModalOpen: storeData.vpp.isModalOpen,
            openModalType: storeData.vpp.openModalType
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        this.setState(
            {
                isModalOpen: storeData.vpp.isModalOpen,
                openModalType: storeData.vpp.openModalType,
            }
        );
    }

    _confirmButtonHandler() {
        goFullScreen('video-iframe-container');
        this.props.store.dispatch(openCloseModal());
    }

    render() {

        return (
            <div className={style.container}>
                <div className={style.buttonsContainer}>
                    <button className={style.confirmButton}
                            onClick={() => this._confirmButtonHandler()}>{getText('OK', this.props.store)}</button>
                    <button className={style.cancelButton}
                            onClick={() => this.props.store.dispatch(openCloseModal())}>{getText('CANCEL', this.props.store)}</button>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(FullScreenConfirmationPopup);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/fullScreenConfirmationPopup.js